<template>
  <div id="wrapper">
    <Globe/>
    <div>
      <PlayerMobile/>
    </div>

    <Welcome />
  </div>
</template>

<script>
import Globe from '../../globe/Globe.vue';
import PlayerMobile from '../../shared/PlayerMobile.vue';
import Welcome from '../../shared/Welcome.vue';

export default {
  name: 'Home',
  components: {
    PlayerMobile,
    Globe,
    Welcome,
  },
};
</script>

<style>
a:link,
a:visited,
a:active {
  color: #6382a0;
}

a:hover {
  color: white;
  text-decoration: underline;
}
</style>
